import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';
import { Checkbox } from 'ui-components/components/checkbox';
import { Text, TextType } from 'ui-components/components/text';
import { featureOptions } from '../constants';
import style from './buttons.module.less';

export const FeatureInterestQuestion = ({ onSelect, selectedInterests }) => {
  const isSelected = useCallback((value) => selectedInterests.includes(value), [selectedInterests]);
  return (
    <div className={style['feature-interest-container']}>
      {featureOptions.map(({ code, message }) => (
        <Button
          key={code}
          className={classnames(style['feature-interest-button'], {
            [style.selected]: isSelected(code),
          })}
          onClick={() => onSelect(code)}
          theme='unstyled'
        >
          <Checkbox checked={isSelected(code)} onChange={() => onSelect(code)} value={code} />
          <Text textType={TextType.Paragraph} value={message} />
        </Button>
      ))}
    </div>
  );
};

FeatureInterestQuestion.propTypes = {
  onSelect: PropTypes.func.isRequired,
  selectedInterests: PropTypes.arrayOf(PropTypes.string).isRequired,
};
